import {gql} from '@apollo/client';

export const QUERY_DOC_LIST = gql`
  query DocList($materialId: ID) {
    docList(material: $materialId) {
      id
      name
      content
    }
  }
`;

export const QUERY_DOC_DETAIL = gql`
  query DocDetail($id: ID!) {
    docDetail(id: $id) {
      id
      name
      content
    }
  }
`;
